import OpenURLBase from "./openurl.base";
import BridgeOpenURL from "../bridge/bridge.openurl";

export default class OpenURLApp extends OpenURLBase {
  
  private bridge: BridgeOpenURL;
  
  constructor() {
    super();
    this.bridge = new BridgeOpenURL();
  }

  public override async open(url:string): Promise<boolean> {
    return this.bridge.openAsync(url);
  }
}